import { SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'
// Advisory Hub (spec-011-advisory-engagements-do-comite, [T062]) — importado
// DIRETO de `constants/TextAdvisory.js`, não do barrel `constants/Text.js`:
// `constants/Text.js` está sendo alterado por outra sessão nesta mesma
// branch (ver o cabeçalho de `TextAdvisory.js`).
import { ADVISORY_TEXT } from '@modules/aawz-intelligence-v2/constants/TextAdvisory'

/**
 * As 2 rotas do Advisory Hub — extraídas de `routes.js` (NICE 16 da review
 * front it.7: o arquivo estava em 500/500, no teto do repo). Arquivo
 * IRMÃO, não um módulo de rotas independente — `routes.js` importa o
 * array e o espalha dentro de `children`, no mesmo lugar de antes.
 *
 * `checkAdvisoryPermission` é INJETADO em vez de importado daqui: ela é
 * declarada em `routes.js` (depende de `checkPermission`, também de lá), e
 * um import de volta para `routes.js` criaria dependência circular entre
 * os dois arquivos.
 */
export default function advisoryRoutes(checkAdvisoryPermission) {
  return [
    {
      path: 'advisory',
      name: 'aawz-intelligence.advisory',
      meta: {
        customPermission: checkAdvisoryPermission,
        search: {
          title: ADVISORY_TEXT.tituloLista,
          description: ADVISORY_TEXT.tituloLista,
          keywords: ['ia', 'advisory', 'comitê', 'consultoria', 'decisão'],
          group: SEARCH_GROUPS.FERRAMENTAS,
        },
      },
      component: () =>
        lazyLoadView(
          import(
            '@modules/aawz-intelligence-v2/views/advisory/view-advisory-list.vue'
          )
        ),
    },
    {
      path: 'advisory/:id',
      name: 'aawz-intelligence.advisory-engagement',
      meta: {
        customPermission: checkAdvisoryPermission,
      },
      component: () =>
        lazyLoadView(
          import(
            '@modules/aawz-intelligence-v2/views/advisory/view-advisory-engagement.vue'
          )
        ),
    },
  ]
}
